import { useEffect, useState } from "react";
import "./style.css";
import Check from "../../Assets/images/Check.png";
import { memo } from "react";

function AssessmentRadioButton({ options, onSubmit, id, answerId }) {
  const [selectedOption, setselectedOption] = useState("");
  const [selectedAnswerIdFromAPI, setselectedAnswerIdFromAPI] = useState("");

  //to pass the selected option to parent component
  useEffect(() => {
    const valueToSubmit =
      selectedOption === undefined || selectedOption === ""
        ? selectedAnswerIdFromAPI
        : selectedOption;

    if (valueToSubmit) {
      onSubmit([valueToSubmit]);
    }
  }, [selectedOption, selectedAnswerIdFromAPI]);

  useEffect(() => {
    if (answerId && answerId.length) {
      const answer = answerId.toString();
      setselectedOption(answer);
    }
  }, [id]);

  //function to handle the change in radio button
  const handleOptionChange = (element) => {
    setselectedOption(element?.id);
  };

 

  return (
    <div className="assess-options-container ">
      {options?.map((option, index) => (
        <div
          className={
            "assess-options" +
            (selectedOption === option?.id ||
            selectedAnswerIdFromAPI === option?.id
              ? " assess-options-active"
              : "")
          }
          id={option?.id}
          key={option?.id}
          onClick={() => handleOptionChange(option)}
        >
          {option?.text}

          <div
            className={
              "custom-radio hover-pointer" +
              (selectedOption === option?.id ||
              selectedAnswerIdFromAPI === option?.id
                ? " checked"
                : "")
            }
          >
            <img src={Check} alt={"&#10003"} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default memo(AssessmentRadioButton);
